import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import $ from "jquery";
import Moment from "moment"
import "react-toastify/dist/ReactToastify.css";

class UserAutoFundModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "this.props.user.id",
      userData: [],
      dataStatus: false,
      portfolioUsdt: 0,
      portfolioInr: 0,
    };
    console.log("this.props", this.props);
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps.currentRecord", nextProps.autoOrderDataById);
    if (nextProps.autoOrderDataById) {
      this.setState({
        userData: nextProps.autoOrderDataById.result,
        dataStatus: nextProps.autoOrderDataById.success,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  tableDataHtml = () => {
    if (this.state.dataStatus == true) {
      const html = [];
      const classThis = this;
      if(this.state.userData.length>0){
        this.state.userData.map((value, i) => {
          html.push(
            <tr>
              <td>{i+1}</td>
            <td>
                {value.PairId.firstCoin.shortName} / {value.PairId.secondCoin.shortName}
              </td>
              <td>
                {value.sell}
              </td>
              <td>{value.qty}</td>
              <td>{value.Trade}</td>
              {/* <td>{value.buy_fees}</td> */}
              <td>{value.orderStatus}</td>
              <td>{value.orderType}</td>
              <td>{Moment.utc(value.createdAt).local().format("lll")}</td>
              {/* <td>
                {Moment(value.created).format('lll')}
              </td> */}
            </tr>
          );
        });
      }
     else{
      html.push(<p className="text-center">No record found</p>)
     }
      return html;
    }
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        <div
          className="modal fade"
          id="update-userauto-modal"
          data-reset="true" data-backdrop="static"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">User Sell Order History</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <table className="table w-100">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Pair</th>
                      <th>Sell Price</th>
                      <th>Quantity</th>
                      <th>Trade Amount</th>
                      <th>Status</th>
                      <th>Order Type</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>{this.tableDataHtml()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserAutoFundModal.propTypes = {
  userFundHistory: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps)(withRouter(UserAutoFundModal));
